import { render, staticRenderFns } from "./EngMainFooter.vue?vue&type=template&id=6880ab75&"
import script from "./EngMainFooter.vue?vue&type=script&lang=js&"
export * from "./EngMainFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports